import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { CircularProgress, Box } from "@mui/material";

const RootRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    let isMounted = true;
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (isMounted) {
        console.log(isMounted + "user:" + user + " : navigating to dashboard since user exists")
        navigate(user ? "/dashboard" : "/login", { replace: true });
      }
    });

    return () => {
      isMounted = false;
      unsubscribe();
    };
  }, [navigate]);

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#0d1b2a",
      }}
    >
      <CircularProgress sx={{ color: "#00eaff" }} />
    </Box>
  );
};

export default RootRedirect;
